import deleteIconOutlined from "./delete_icon_outlined.png";
import deleteIconRed from "./delete_icon_red.png";
import deleteIcon from "./remove_icon_24px_light.png";

type DeleteIconProps = {
  color?: "light" | "red" | "outlined";
  height?: number;
  onClick?: () => void;
};

const DELETE_IMAGES: Record<"light" | "red" | "outlined", string> = {
  light: deleteIcon,
  red: deleteIconRed,
  outlined: deleteIconOutlined
};

export const DeleteIcon = ({ color = "light", height = 20, onClick }: DeleteIconProps) => (
  <img
    src={DELETE_IMAGES[color]}
    height={height}
    alt="Delete icon"
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", height: "100%" }}
  />
);
